import { useState } from 'react'
import { downloadProjectVault } from '../../api/projects'

export default function PulseDownloadAll({
  projectId,
  testId,
  className = 'btn b-ol btn-sm',
}: {
  projectId: number
  testId: string
  className?: string
}) {
  const [busy, setBusy] = useState(false)
  const [err, setErr] = useState('')
  return (
    <span className="pulse-download-all-wrap">
      <button
        type="button"
        className={className}
        data-testid={testId}
        disabled={busy}
        onClick={async () => {
          setBusy(true)
          setErr('')
          try {
            await downloadProjectVault(projectId)
          } catch (e) {
            setErr(e instanceof Error ? e.message : 'Download failed')
          } finally {
            setBusy(false)
          }
        }}
      >
        {busy ? 'Preparing…' : 'Download all files'}
      </button>
      {err ? <span className="pulse-add-files-error">{err}</span> : null}
    </span>
  )
}
